var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlugOnDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(6 3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M9.363 3.656V0H8.044v3.656H3.956V0H2.637v3.656H0v7.172c0 2.326 1.775 4.219 3.956 4.219h1.385V18h1.318v-2.953h1.385c2.181 0 3.956-1.893 3.956-4.219V3.656H9.363zm1.318 7.172c0 1.551-1.183 2.813-2.637 2.813H3.956c-1.454 0-2.637-1.262-2.637-2.813V5.063h9.362v5.765zm-4.528-.95H3.857l1.45-3.48h1.441l-.847 2.075h2.295l-1.418 3.164-1.154.703v-1.336l.53-1.125z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugOnDark);
export default __webpack_public_path__ + "static/media/plug-on-dark.e63420ced62357111418614e573bca20.svg";
export { ForwardRef as ReactComponent };